<template>
  <mu-col>
    <mu-card class="messageContainer" v-bind:class="messageClass">
      <div class="titleWrap">
        <img class="titleIcon" v-bind:src="messageIcon"> <span class="titleText">{{title}}</span>
      </div>
      <div class="bodyWrap">
        <span class="bodyText">{{message}}</span>
      </div>
    </mu-card>
  </mu-col>
</template>

<script>
  export default {
    name: "MessageBox",
    props: {
      title: String,
      message: String,
      messageType: String
    },
    computed: {
      messageClass: function () {
        const self = this;
        let containerClass = "info";
        if (self.messageType === 'error') {
          containerClass = "error"
        }
        if (self.messageType === 'success') {
          containerClass = "success"
        }
        return containerClass;
      },
      messageIcon: function () {
        const self = this;
        let messageIcon = "https://res.cloudinary.com/grohealth/image/upload/v1587108815/Low%20Carb%20Program/Email-Assets/warning-yellow-24px.png";
        if (self.messageType === 'error') {
          messageIcon = "https://res.cloudinary.com/grohealth/image/upload/v1587109063/Low%20Carb%20Program/Email-Assets/warning-red-24px.png"
        }
        if (self.messageType === 'success') {
          messageIcon = "https://res.cloudinary.com/grohealth/image/upload/v1587108821/Low%20Carb%20Program/Email-Assets/ic_small_circle_tick.png"
        }
        return messageIcon;
      }
    }
  }
</script>

<style scoped>
  .messageContainer {
    border-radius: 4px;
    background: #fff6d0;
    text-align: left;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    padding: 24px 30px;
    margin-bottom: 36px;
  }

  .messageContainer.error {
    background: #fbebea;
  }

  .messageContainer.success {
    background: #f4ffe6;
  }

  .messageContainer .titleWrap {
    display: flex;
    align-items: center;
  }

  .messageContainer .titleText {
    font-size: 28px;
    font-weight: bold;
    color: #000000;
    margin-left: 12px;
  }

  .messageContainer .bodyText {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: 0.01px;
    text-align: left;
    color: #000000;
    margin-top: 12px
  }
</style>



// WEBPACK FOOTER //
// MessageBox.vue?7b51bef9